import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VendorPurchaseOrders'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VendorPurchaseOrdersStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VendorPurchaseOrdersStore",
			variables: true,
		})
	}
}

export async function load_VendorPurchaseOrders(params) {
  await initClient()

	const store = new VendorPurchaseOrdersStore()

	await store.fetch(params)

	return {
		VendorPurchaseOrders: store,
	}
}
